import { useEffect, useRef, useState } from 'react';
import RedDelete from "../../Assets/redDelete.svg";
import { showToast } from '../../Components/Toaster/Toaster';
import { deleteProductFromCustomCollection, getCustomCollection } from '../../lib/utils/apiCalls';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCustomCollectionData } from '../../Features/collectionsSlice';

function ProductBox({ product, imageUrl }) {
    const dispatch = useDispatch();
    const params = useParams();
    const imageContainerRef = useRef(null);

    const [hoverOnDiv, setHoverOnDiv] = useState(false);
    const [buttonsVisible, setButtonsVisible] = useState(false);

    const [mediaContainerHeight, setMediaContainerHeight] = useState(0);

    const handleDeleteProductFromCollection = async (e) => {
        e.preventDefault();

        try {
            const customCollectionId = params.customCollectionId;
            const productId = product.id;
            const response = await deleteProductFromCustomCollection(customCollectionId, productId);
            if(response?.status === 200) {
                showToast('Product removed.', 'success');
                try {
                    const response = await getCustomCollection(params.customCollectionId);
                    if(response?.status === 200) {
                        dispatch(setCustomCollectionData(response.data.data));
                    }
                }
                catch(err) {
                    showToast('Error fetching products list.', 'error');
                }
            }
            else {
                showToast('Error removing product.', 'error');
            }
        }
        catch(err) {
            showToast('Error removing product.', 'error');
        }
    }

    useEffect(() => {
        if(hoverOnDiv) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnDiv]);

    useEffect(() => {
        if(imageContainerRef.current) {
            setMediaContainerHeight(imageContainerRef.current.clientWidth);
        }
    }, [imageContainerRef]);

    return (
        <Link 
            to={`/inventory-management/product/${product.id}`} 
            onMouseEnter={() => setHoverOnDiv(true)} 
            onMouseLeave={() => setHoverOnDiv(false)} 
            className='relative border border-[#EAEAEA] w-full rounded-xl overflow-hidden shadow-[0px_0px_12px_0px_#0000003D]'
        >
            <div ref={imageContainerRef} className="flex items-center justify-center w-full" style={{ height: `${mediaContainerHeight}px` }}>
                <img className='max-w-full max-h-full' src={imageUrl} alt="" />
            </div>

            <div className="p-3 flex flex-col gap-1 text-[#666666] select-none">
                <h1 className='text-base font-semibold w-full whitespace-nowrap overflow-hidden text-ellipsis'>{product?.productName}</h1>

                <p className='text-[12px] leading-5 font-medium w-full whitespace-nowrap overflow-hidden text-ellipsis'>{product?.productDesc}</p>
            </div>

            {
                buttonsVisible && 
                <div className="absolute top-0 right-0 size-11 flex items-center justify-center">
                    <button onClick={handleDeleteProductFromCollection} className="size-8 flex items-center justify-center rounded-full bg-[#FFFFFF] outline-none shadow-[0px_0px_12px_0px_#0000003D]">
                        <img src={RedDelete} alt="" />
                    </button>
                </div>
            }
        </Link>
    )
}

export default ProductBox;
